'use strict';

import angular from 'angular';
import AddController from './add.controller';

export default angular.module('updateServerApp.peripheral.add', [])
  .controller('PeripheralAddController', AddController)
  .name;



// WEBPACK FOOTER //
// ./client/app/peripheral/add/index.js